import type { FaireProductEntity } from "../../entity_types/product";

export const p_24ua1fyo: FaireProductEntity = {
  token: "p_24ua1fyo",
  type: "product",
  name: "No. 10 - Basil Mint + Lavender Candle",
  brandToken: "b_oaph28jf",
  brandName: "dilo",
  imageUrl:
    "https://cdn.faire.com/fastly/ef9be87b6136277be320ccc89652bbfff5015876c0589620f2b89f0e1a3bc0b9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f99d3455f6a16440e21cd41e587cd1133367e5ae234d7550c310ef129c20ced8.jpeg",
    "https://cdn.faire.com/fastly/91aa0fce6c1af2aed96fa20f9021684015428ec704e5809db870aa8b124d93b2.jpeg",
    "https://cdn.faire.com/fastly/dbcda0406970bde5542612544f9f1c666207b294fd059cd673e2d90c0767c3f7.jpeg",
    "https://cdn.faire.com/fastly/1614b4e054bd77b84d93be11c443ab7ecd138f6aa19796789f53c34d6a066f92.jpeg",
  ],
  priceDollars: 6,
  description:
    "dilo candles are hand poured and made using 100% USA grown Soy Wax. \n\nNo. 10 - Basil Mint + Lavender has notes of fresh mint and lavender while also provide undertones of wood and earthy scents.\n\nTop Notes: Mint Leaves - Basil\nHeart: Lavender - Peppermint\nBase: Musk - Orange Blossom - Wood\n\n12.5 oz - burns for 65-70 hours - the ideal size for living rooms, larger spaces, and rooms with higher ceilings.\n7.5 oz - burns for 40-50 hours - will slowly fill a medium sized space, without ever feeling overpowering. \n3.5oz - burns for 20-25 hours - the perfect size candle for bathrooms or small office spaces.\n\n\nAll candles are Phthalate-free, using cotton wicks with no lead cores for safer, cleaner burning.\n\nShop this same scent in Reed Diffusers and Room Sprays\n",
  tags: [],
  msrpDollars: 12,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:07.429Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
